<template>
<div :class="{ 'modal-mode': isInModal }">
    <!-- Loading State -->
    <div v-if="isLoading" class="loading-overlay2">
        <div>
            <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="50px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                <circle cx="50" cy="50" fill="none" stroke="#e9ff86" stroke-width="10" r="35" stroke-dasharray="165 57">
                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.5s" values="0 50 50;360 50 50" keyTimes="0;1" />
                </circle>
            </svg>
        </div>
    </div>

    <!-- Error State -->
    <div v-else-if="error" class="error-container" style="display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 50vh; text-align: center; padding: 20px;">
        <h2>{{ error }}</h2>
        <router-link to="/" class="button-135 w-button">Go Back Home</router-link>
    </div>

    <!-- Main Content -->
    <template v-else>
        <!-- Promo Bar - Hidden in modal mode -->
        <section v-if="!isInModal" class="promo-section"></section>

        <!-- Navigation - Hidden in modal mode -->
        <section v-if="!isInModal" id="navtest" class="nav nscrtest">
            <div class="promo-div">
                <div class="promo-box">
                    <div class="text-block-775">
                        <span class="text-span-181">LIMITED TIME: </span>FREE OVERNIGHT SHIPPING &amp; DOCTOR REVIEW
                    </div>
                </div>
            </div>
            <div class="nav-holder-div">
                <div class="nav-bar-div weight hide-block w-clearfix">
                    <router-link to="/" class="brand w-nav-brand">
                        <img loading="lazy" src="@/assets/images/NewSelf_Logo.webp" alt="" class="nav-logo">
                    </router-link>
                    <div class="div-block-1714">
                        <a href="#" class="link-block-68 w-inline-block" @click.prevent="openCart">
                            <img loading="lazy" src="@/assets/images/icon_-cart.svg" alt="" class="image-422">
                            <div class="div-block-1788" v-if="cartItemCount > 0">
                                <div class="text-block-859">{{ cartItemCount }}</div>
                            </div>
                        </a>
                    </div>
                </div>
                <div data-animation="default" data-collapse="medium" data-duration="400" data-easing="ease" data-easing2="ease" role="banner" class="navbar-3 w-nav">
                    <router-link to="/" class="brand-4 w-nav-brand">
                        <img loading="lazy" src="@/assets/images/NewSelf_Logo.webp" alt="" class="nav-logo weight">
                    </router-link>
                    <nav role="navigation" class="nav-menu-4 w-nav-menu">
                        <a href="#" class="button-158 w-button" @click.prevent="scrollToProduct">Get Started</a>
                    </nav>
                    <div class="menu-button-4 w-nav-button">
                        <div class="icon-42 w-icon-nav-menu"></div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Product Section -->
        <section class="product-section">
            <div class="nad-product-div-wrap">
                <div class="product-div-box">
                    <!-- Product Images -->
                    <div class="product-images-div">
                        <!-- Main Slider -->
                        <div class="product-slider w-slider" id="product-slider">
                            <div class="mask-13 w-slider-mask">
                                <div v-for="(img, index) in productImages" :key="index" :id="`slide-${index + 1}`" class="product-slide template slidecpy w-slide" :style="{ display: currentSlide === index ? 'block' : 'none' }">
                                    <a href="#" class="lightbox-link w-inline-block">
                                        <div class="product-img-div template">
                                            <img :src="img" loading="lazy" alt="" class="slideimg template">
                                        </div>
                                    </a>
                                </div>
                            </div>
                            <div class="product-slider-left-arrow w-slider-arrow-left" @click="prevSlide">
                                <div class="product-slider-arrow-icon w-icon-slider-left"></div>
                            </div>
                            <div class="product-slider-right-arrow w-slider-arrow-right" @click="nextSlide">
                                <div class="product-slider-arrow-icon w-icon-slider-right"></div>
                            </div>
                            <div class="slide-nav-4 w-slider-nav w-round w-num">
                                <div v-for="(img, index) in productImages" :key="index" class="w-slider-dot" :class="{ 'w-active': currentSlide === index }" @click="currentSlide = index">
                                </div>
                            </div>
                        </div>

                        <!-- Category Badge -->
                        <div class="category">LONGEVITY</div>

                        <!-- Thumbnail Gallery -->
                        <div class="img-links-div">
                            <div class="div-block-2154">
                                <a v-for="(img, index) in productImages.slice(0, 8)" :key="index" href="#" :class="`gallery-link${index + 1} w-inline-block`" @click.prevent="currentSlide = index">
                                    <img :src="img" loading="lazy" alt="">
                                </a>
                            </div>
                        </div>

                        <!-- UGC Videos Section -->
                        <div class="ugc-div" v-if="!isInModal">
                            <div class="text-block-1783">Real People. Real Results.</div>
                            <div class="videos-div-copy-copy-2">
                                <div class="videos-slider-3 w-slider" ref="videoSlider" @touchstart="handleTouchStart" @touchmove="handleTouchMove" @touchend="handleTouchEnd">
                                    <div class="mask-8 w-slider-mask">
                                        <div class="slider-track" :style="sliderStyle">
                                            <div v-for="(video, index) in testimonialVideos" :key="index" class="video-slide-3 w-slide">
                                                <div class="video-card-div">
                                                    <div class="background-video-13">
                                                        <video :id="'video-' + index" loop muted playsinline :poster="video.poster" data-object-fit="cover" preload="metadata">
                                                            <source :src="video.src" type="video/mp4">
                                                        </video>
                                                        <div aria-live="polite">
                                                            <button type="button" class="w-backgroundvideo-backgroundvideoplaypausebutton play-pause-button w-background-video--control" @click="toggleVideo(index)">
                                                                <span :hidden="!videoPlaying[index]">
                                                                    <img loading="lazy" src="https://uploads-ssl.webflow.com/6022af993a6b2191db3ed10c/628299f8aa233b83918e24fd_Pause.svg" alt="Pause video">
                                                                </span>
                                                                <span :hidden="videoPlaying[index]">
                                                                    <img loading="lazy" src="https://uploads-ssl.webflow.com/6022af993a6b2191db3ed10c/628298b20ae0236682d4b87f_Play-24.svg" alt="Play video">
                                                                </span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="left-arrow-19 w-slider-arrow-left" @click="prevVideoSlide">
                                        <div class="icon-51 w-icon-slider-left"></div>
                                    </div>
                                    <div class="right-arrow-17 w-slider-arrow-right" @click="nextVideoSlide">
                                        <div class="icon-51 w-icon-slider-right"></div>
                                    </div>
                                    <div class="slide-nav-8 w-slider-nav w-slider-nav-invert w-round">
                                        <div v-for="(_, index) in totalSlides" :key="index" class="w-slider-dot" :class="{ 'w-active': currentDotIndex === index }" @click="goToSlide(index)">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Product Details -->
                    <div class="product-detail-div">
                        <div class="category_mobile body">MITOCHONDRIA</div>

                        <!-- Ratings -->
                        <div class="ratings-div">
                            <img src="@/assets/images/icon_stars.svg" loading="lazy" alt="" class="image-394">
                            <div class="trustpilot-rating-div">
                                <div class="trustpilot-rating-text">Excellent</div>
                                <div class="trustpilot-score-text">4.6 out of 5</div>
                                <img src="@/assets/images/Trustpilot_Logo_2022.svg.webp" loading="lazy" alt="" class="trustpilot-rating-logo">
                            </div>
                        </div>

                        <!-- Product Name & Price -->
                        <div class="product-name-box">
                            <div class="product-name">NAD+™</div>
                            <div class="text-block-866 hide">Compound Medication</div>
                        </div>
                        <div class="product-price-flex" v-if="!isInModal">
                            <div class="old-price-text">${{ displayOriginalPrice }}</div>
                            <div class="price-text">${{ displayCurrentPrice }}</div>
                            <div>
                                <div class="savings-text">ALL DOSAGES</div>
                            </div>
                        </div>

                        <div class="line-divider"></div>

                        <!-- Description -->
                        <div class="description-header-text">Revolutionary Approach to Clean Cellular Energy.</div>
                        <p class="paragraph-169">NAD+ uses naturally fermented NAD+ produced in Japan under pharmaceutical-grade standards.</p>

                        <!-- Product Bullets -->
                        <div class="prod-bullets-div sales">
                            <div v-for="(bullet, index) in productBullets" :key="index" class="prod-bullet" :class="{ bottom: index === productBullets.length - 1 }">
                                <img src="@/assets/images/icon_check_LGreenBlkoutline.svg" loading="lazy" alt="" class="image-568">
                                <div class="text-block-1329" v-html="bullet"></div>
                            </div>
                        </div>

                        <div class="line-divider"></div>

                        <!-- Treatment Summary -->
                        <div class="treatment-summary-div">
                            <div class="treatment-summary quarterly">
                                <div class="treatsum_headerdiv">
                                    <div class="text-block-1040">YOUR TREATMENT SUMMARY</div>
                                </div>
                                <div class="treatsum_deetsdiv">
                                    <div class="treatsum_inclusionsdiv">
                                        <div class="treatsum_perkdiv">
                                            <img src="@/assets/images/icon_board-copy.svg" loading="lazy" alt="" class="image-474">
                                            <div class="text-block-1041">Initial Telehealth Visit</div>
                                        </div>
                                        <div class="treatsum_perkdiv">
                                            <img src="@/assets/images/icon_meds-copy.svg" loading="lazy" alt="" class="image-474">
                                            <div class="text-block-1041">Prescription + Medication</div>
                                        </div>
                                    </div>
                                    <div class="treatsum_inclusionsdiv">
                                        <div class="treatsum_perkdiv">
                                            <img src="@/assets/images/icon_support.svg" loading="lazy" alt="" class="image-474">
                                            <div class="text-block-1041">24/7 Support</div>
                                        </div>
                                        <div class="treatsum_perkdiv">
                                            <img src="@/assets/images/icon_appointment.svg" loading="lazy" alt="" class="image-474">
                                            <div class="text-block-1041">Monthly check-in</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Medication Form -->
                        <div class="product-form w-form" v-if="!isInModal">
                            <form id="email-form" name="email-form">
                                <!-- Medication Type Selection -->
                                <div class="med-type-div left-align nad">
                                    <div class="text-block-1776">Choose Medication</div>
                                    <div class="div-block-2283">
                                        <div class="div-block-2285" :class="{ 'selected-option': selectedMedType === 'nasal' }">
                                            <label class="radio-button-field-4 w-radio" @click="selectedMedType = 'nasal'">
                                                <input type="radio" name="medType" class="w-form-formradioinput radio-button-3 w-radio-input" :checked="selectedMedType === 'nasal'">
                                                <span class="radio-button-label-8 hide w-form-label">Nasal</span>
                                                <div class="text-block-1781">Easy Application</div>
                                                <div class="div-block-2284">
                                                    <img src="@/assets/images/Main-image_NADNasal.webp" loading="lazy" alt="" class="medtype-img">
                                                    <div class="text-block-1778">Nasal</div>
                                                </div>
                                                <img src="@/assets/images/icon_info_1.svg" loading="lazy" alt="" class="info-1">
                                            </label>
                                            <div class="popup-text-1">The easiest routine to stick with daily if you don't like needles.</div>
                                        </div>
                                        <div class="div-block-2285" :class="{ 'selected-option': selectedMedType === 'injectable' }">
                                            <label class="radio-button-field-4 w-radio" @click="selectedMedType = 'injectable'">
                                                <input type="radio" name="medType" class="w-form-formradioinput radio-button-3 w-radio-input" :checked="selectedMedType === 'injectable'">
                                                <span class="radio-button-label-8 hide w-form-label">Injectable</span>
                                                <div class="text-block-1781-copy">Highest Efficacy</div>
                                                <div class="div-block-2284">
                                                    <img src="@/assets/images/NS_nad-vial_tilt.webp" loading="lazy" alt="" class="medtype-img">
                                                    <div class="text-block-1778">Injectable</div>
                                                </div>
                                                <img src="@/assets/images/icon_info_1.svg" loading="lazy" alt="" class="info-2">
                                            </label>
                                            <div class="popup-text-2">Instant energy upgrade felt throughout the day without effecting sleep.</div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Dosage Selection (only for Injectable) -->
                                <div v-if="selectedMedType === 'injectable'" class="med-type-div left-align nad">
                                </div>
                                <div class="text-block-1776 plan">Choose Payment Plan</div>

                                <!-- Payment Plan Selection -->
                                <div class="_3-button-div">
                                    <div class="upsell_option" :class="{ 'selected-option': selectedPlan === 'onetime' }">
                                        <label class="payplan-choice w-radio" @click="selectedPlan = 'onetime'">
                                            <input type="radio" name="plan" class="w-form-formradioinput radio-button-4 w-radio-input" :checked="selectedPlan === 'onetime'">
                                            <span class="radio-button-label-7 w-form-label">Radio</span>
                                            <div class="div-block-2282">
                                                <div class="div-block-2280">
                                                    <div class="month-text">1 Month Supply</div>
                                                    <p class="paragraph-230">One Time Purchase</p>
                                                </div>
                                                <div class="plan-price-box">
                                                    <div class="payplan-price"><span class="text-span-442"><sup class="price-cents">$</sup></span>{{ planPrices.oneTime.dollars }}<sup class="price-cents prod">{{ planPrices.oneTime.cents }}</sup><span class="text-span-440">/mo</span></div>
                                                    <div class="text-block-1774"><strong>1 Month Supply</strong></div>
                                                    <div class="text-block-1775">Monthly Doctor Review</div>
                                                </div>
                                            </div>
                                        </label>
                                    </div>
                                    <div class="upsell_option" :class="{ 'selected-option': selectedPlan === 'subscribe' }">
                                        <label class="payplan-choice w-radio" @click="selectedPlan = 'subscribe'">
                                            <input type="radio" name="plan" class="w-form-formradioinput radio-button-4 w-radio-input" :checked="selectedPlan === 'subscribe'">
                                            <span class="radio-button-label-7 w-form-label">Radio</span>
                                            <div class="div-block-2282">
                                                <div class="div-block-2280">
                                                    <div class="month-text">Subscribe &amp; Save</div>
                                                    <p class="paragraph-230">Never miss a refill &amp; Save</p>
                                                </div>
                                                <div class="plan-price-box">
                                                    <div class="payplan-price"><sup class="price-cents">$</sup>{{ planPrices.monthly.dollars }}<sup class="price-cents prod">{{ planPrices.monthly.cents }}</sup><span class="text-span-440">/mo</span></div>
                                                    <div class="text-block-1775">1 Month Supply<br><span class="text-span-441">Save ${{ monthlySavings }} a month!</span></div>
                                                </div>
                                            </div>
                                        </label>
                                    </div>
                                    <div class="upsell_option" :class="{ 'selected-option': selectedPlan === 'quarterly' }">
                                        <label class="payplan-choice w-radio" @click="selectedPlan = 'quarterly'">
                                            <input type="radio" name="plan" class="w-form-formradioinput radio-button-4 w-radio-input" :checked="selectedPlan === 'quarterly'">
                                            <span class="radio-button-label-7 w-form-label">Radio</span>
                                            <div class="div-block-2282">
                                                <div class="div-block-2280">
                                                    <div class="month-text">3 Month Supply</div>
                                                    <p class="paragraph-230">Commit Longer, Save More.</p>
                                                </div>
                                                <div class="plan-price-box">
                                                    <div class="payplan-price"><sup class="price-cents">$</sup>{{ planPrices.threeMonthAvg.dollars }}<sup class="price-cents prod">{{ planPrices.threeMonthAvg.cents }}</sup><span class="text-span-440">/mo avg.</span></div>
                                                    <div class="text-block-1775">Pay <strong>${{ planPrices.threeMonthTotal }}</strong> Today<br><strong>Save ${{ quarterlySavings }} a month!</strong></div>
                                                </div>
                                            </div>
                                        </label>
                                    </div>
                                </div>
                            </form>
                        </div>

                        <!-- Add to Cart Button -->
                        <a v-if="showButtons" href="#" class="add-to-cart-bttn w-button" @click.prevent="addToCart">ADD TO CART</a>

                        <!-- Perks -->
                        <div class="perks-div">
                            <div class="perk-div ship">
                                <img src="@/assets/images/icon_shipping.svg" loading="lazy" alt="" class="image-386">
                                <div class="text-block-738"><strong>Overnight</strong> Shipping</div>
                            </div>
                            <div class="perk-div sema">
                                <img src="@/assets/images/icon_check-black2.svg" loading="lazy" alt="" class="image-386 refund">
                                <div class="text-block-738"><strong>Full Refund</strong> if Declined By Doctor</div>
                            </div>
                        </div>

                        <!-- Payment Methods & Delivery -->
                        <div class="div-block-2290">
                            <img src="@/assets/images/Payment_Methods.webp" loading="lazy" alt="" class="image-399">
                            <div class="order-arival-div">
                                <img src="@/assets/images/icon__Alert-dot.svg" loading="lazy" alt="" class="image-396">
                                <div class="text-block-770">Order today and get it by <strong>{{ estimatedDelivery }}</strong></div>
                            </div>
                            <div class="delivery-disclaimer">*Mon - Thursday Overnight Shipping (Not on Weekends)</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Science Section: It's Not Age. It's Biology -->
        <section class="page-section">
            <div class="semasci_wrap">
                <div class="semasci_div-copy">
                    <div class="semasci_infodiv-copy-copy">
                        <div class="semasci_header">It's Not Age. It's Biology.</div>
                        <div class="text-block-1782">It's not you. It's your cells — they're running low on fuel.</div>
                        <div class="semasci_sub-copy">You wake up tired. Energy fades early. Recovery slows. Focus slips. You blame stress, work, kids, sleep - then age. <strong>But that's not the real reason.</strong></div>
                        <div class="info-boxes _65percent">
                            <div class="div-block-2259">
                                <div class="div-block-2263">
                                    <div class="div-block-2260">
                                        <img src="@/assets/images/icon_arrowdown.svg" loading="lazy" alt="">
                                    </div>
                                    <div class="div-block-2261 b">
                                        <div class="text-block-1745">65%</div>
                                        <div class="text-block-1746"><em class="italic-text-14">Decrease in NAD+</em></div>
                                    </div>
                                </div>
                                <div class="div-block-2262">
                                    <p class="paragraph-224">After your 30s, the molecules that power your cells naturally decline. <strong>Sleep, stress, and everyday life accelerate the drop.</strong></p>
                                </div>
                            </div>
                        </div>
                        <div class="info-boxes f6-grey">
                            <div class="div-block-2259">
                                <div class="div-block-2262-copy quote-copy">
                                    <div class="div-block-2260 id-pic">
                                        <img src="@/assets/images/Dr-Fenton-LeBon-MD.png" loading="lazy" alt="">
                                    </div>
                                    <p class="paragraph-224-copy quote-copy">At 40, even as a doctor, I woke up without answers to why my body was changing so rapidly. Then I discovered NAD+—and it became my life's work.</p>
                                </div>
                                <div class="div-block-2261 right-alight">
                                    <div class="text-block-1748">Dr. Fenton Lebon</div>
                                    <div class="text-block-1749">Creator of NAD+</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="semasci_mediadiv">
                        <img src="@/assets/images/NanoNADGraph_1.gif" loading="lazy" alt="" class="image-481-copy _65">
                    </div>
                </div>
            </div>
        </section>

        <!-- Science Section: The Science Behind NanoNAD+ -->
        <section class="page-section">
            <div class="semasci_wrap-copy">
                <div class="nadsection_main_div flip">
                    <div class="pagesection_infodiv">
                        <div class="semasci_header">The Science Behind NAD+™</div>
                        <div class="semasci_sub"><strong>NAD+™</strong> is a new, patented, revolutionary approach to <strong>clean cellular energy.</strong> Highly absorbable. Naturally fermented. Free from stimulants, toxins, and synthetic shortcuts.</div>
                        <div class="semasci_bulletsdiv">
                            <div class="semasci_bulletsrow">
                                <div class="semasci_bullet">
                                    <img src="@/assets/images/icon_check_blkoutline.svg" loading="lazy" alt="" class="image-480">
                                    <div class="text-block-1050">Supports anti-aging</div>
                                </div>
                                <div class="semasci_bullet">
                                    <img src="@/assets/images/icon_check_blkoutline.svg" loading="lazy" alt="" class="image-480">
                                    <div class="text-block-1050">Improved mood</div>
                                </div>
                            </div>
                            <div class="semasci_bulletsrow">
                                <div class="semasci_bullet">
                                    <img src="@/assets/images/icon_check_blkoutline.svg" loading="lazy" alt="" class="image-480">
                                    <div class="text-block-1050">Boost energy</div>
                                </div>
                                <div class="semasci_bullet">
                                    <img src="@/assets/images/icon_check_blkoutline.svg" loading="lazy" alt="" class="image-480">
                                    <div class="text-block-1050">Mental Clarity</div>
                                </div>
                            </div>
                        </div>
                        <div class="semasci_buttondiv">
                            <a v-if="showButtons" href="#" class="button-135 w-button" @click.prevent="scrollToProduct">BUY NOW <span class="text-span-297">-&gt;</span></a>
                        </div>
                    </div>
                    <div class="semasci_mediadiv">
                        <img src="@/assets/images/NS_NadChart-01.webp" loading="lazy" alt="" class="image-481-copy">
                    </div>
                </div>
            </div>
        </section>

        <!-- Comparison Table Section -->
        <section class="page-section">
            <div class="page-section-wrap">
                <div class="nadsection_main_div">
                    <div class="pagesection_infodiv">
                        <div class="semasci_header">Your Pharmaceutical NAD+ is Full of Sh*T</div>
                        <div class="nad-paragraph">Most NAD+ currently offered by other telehealth companies burns, creates welts and is an unpleasant experience. Why?</div>
                        <div class="nad-paragraph">It is synthetic, full of by products, heavy metals and junk…right off the boat from Chinese mass production laboratories.</div>
                        <div class="nad-paragraph">Our NAD+ is made through a natural, fermentation process, in small batches, in Japan, free of all pollutants</div>
                        <div class="nad-paragraph last">99% Purity on COAs looks good to the blind eye, but not when cadmium and other toxic 1% is in the drugs. Chemical plants have heavy metal catalysts. You don't want this in your brain!</div>
                        <div class="semasci_buttondiv">
                            <a v-if="showButtons" href="#" class="button-135 w-button" @click.prevent="scrollToProduct">BUY NOW <span class="text-span-297">-&gt;</span></a>
                        </div>
                    </div>
                    <div class="comp-table-main-div">
                        <div class="jap-vs-table">
                            <div class="div-block-2025"></div>
                            <div class="div-block-2026"></div>
                            <div class="table-headers-row top">
                                <div class="table-spacer-div"></div>
                                <div class="table-imgs-div">
                                    <div class="table-img-holder">
                                        <img src="@/assets/images/salespage-images-madeinjapan.png" loading="lazy" alt="" class="image-712">
                                    </div>
                                    <div class="versus-copy">
                                        <div class="text-block-1445">VS</div>
                                    </div>
                                    <div class="table-img-holder">
                                        <img src="@/assets/images/salespage-images-china.png" loading="lazy" alt="" class="image-712">
                                    </div>
                                </div>
                            </div>
                            <div class="table-body-row-copy brand-bar">
                                <div class="comptable_category top nad"></div>
                                <div class="jap-vs-header nano">
                                    <div class="text-block-1444 brand">NAD+™️</div>
                                </div>
                                <div class="comp-table-entry nad">
                                    <div class="text-block-1444-copy brand-copy nad">Most NAD</div>
                                </div>
                            </div>
                            <div v-for="(row, index) in comparisonTable" :key="index" class="table-body-row-copy">
                                <div class="comptable_category" :class="{ 'bottom-1': index === comparisonTable.length - 1 }">
                                    <div class="text-block-1363">{{ row.category }}</div>
                                </div>
                                <div class="jap-vs-entry japan">
                                    <img src="@/assets/images/icon_check_LGreenBlkoutline.svg" loading="lazy" alt="" class="image-585">
                                    <div class="text-block-1441">{{ row.nanonad }}</div>
                                </div>
                                <div class="jap-vs-entry">
                                    <img src="@/assets/images/icon_No_1.svg" loading="lazy" alt="" class="image-585">
                                    <div class="text-block-1441">{{ row.others }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Why NanoNAD+ Is Different Section -->
        <section class="page-section">
            <div class="semasci_wrap-copy-copy-copy">
                <div class="nadsection_main_div flip">
                    <div class="semasci_infodiv-copy">
                        <div class="semasci_header">Why NAD+™️ Is Different</div>
                        <div class="text-block-1782">Most NAD options sound good - but fall apart in real life.</div>
                        <div v-for="(item, index) in competitorComparison" :key="index" class="div-block-2291">
                            <div class="nad-small-header">{{ item.header }}</div>
                            <div class="nad-sectionsubs">{{ item.description }}</div>
                        </div>
                    </div>
                    <div class="semasci_mediadiv">
                        <img src="@/assets/images/NanoNADGraph_SQ_New.gif" loading="lazy" alt="" class="image-481-copy">
                    </div>
                </div>
            </div>
        </section>

        <!-- Why NAD+™? Highlights Section -->
        <section>
            <div class="highlights_wrap">
                <div class="highlight-div">
                    <div class="highlights_flex">
                        <div class="highlights_text_div">
                            <h1 class="highlights-heading">Why NAD+™?<br></h1>
                            <p class="paragraph-198">Our revolutionary NAD+ formula delivers clean cellular energy through a natural fermentation process, providing benefits you can feel from day one.</p>
                        </div>
                        <div class="highlights_imgdiv">
                            <div class="feature-div top">
                                <div class="text-block-1577"><strong>Enhanced energy</strong> production</div>
                            </div>
                            <div class="img-flex-div">
                                <div class="div-block-2156">
                                    <div class="feature-div">
                                        <div class="text-block-1577">Aids <strong>cellular repair</strong></div>
                                    </div>
                                    <div class="feature-div">
                                        <div class="text-block-1577">Boosts <strong>focus</strong> and promotes <strong>mental clarity</strong></div>
                                    </div>
                                </div>
                                <div class="hl_prodimgdiv">
                                    <img src="@/assets/images/nano.png" loading="lazy" alt="">
                                </div>
                                <div class="div-block-2156">
                                    <div class="feature-div">
                                        <div class="text-block-1577"><strong>Supports anti-aging</strong> processes</div>
                                    </div>
                                    <div class="feature-div">
                                        <div class="text-block-1577">Promotes <strong>DNA repair</strong> mechanisms</div>
                                    </div>
                                </div>
                            </div>
                            <a v-if="showButtons" href="#" class="button-161 w-button" @click.prevent="scrollToProduct">Buy Now</a>
                            <p class="paragraph-199">*These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure, or prevent any disease.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Review Section -->
        <section class="review-section">
            <div class="review-wrap">
                <div class="reviews-div">
                    <div class="reviews-flex-div">
                        <div class="review-box">
                            <img src="@/assets/images/icon_stars_1.svg" loading="lazy" alt="" class="image-417">
                            <p class="paragraph-133">"I've been using NAD+ for 3 months and the difference in my energy levels is remarkable. No more afternoon crashes!"</p>
                            <div class="reviewer-div">
                                <div class="reviewer-img-div">
                                    <img src="@/assets/images/testi1.webp" loading="lazy" alt="">
                                </div>
                                <div class="reviewer-info">
                                    <div class="text-block-832">Tommy J.</div>
                                    <div class="text-block-833">Baltimore, MD</div>
                                </div>
                            </div>
                        </div>
                        <div class="review-box">
                            <img src="@/assets/images/icon_stars_1.svg" loading="lazy" alt="" class="image-417">
                            <p class="paragraph-133">"Finally, a NAD+ that doesn't burn! The nasal spray is so easy to use and I feel the effects within minutes."</p>
                            <div class="reviewer-div">
                                <div class="reviewer-img-div">
                                    <img src="@/assets/images/testi3.webp" loading="lazy" alt="">
                                </div>
                                <div class="reviewer-info">
                                    <div class="text-block-832">Erica B.</div>
                                    <div class="text-block-833">San Antonio, TX</div>
                                </div>
                            </div>
                        </div>
                        <div class="review-box">
                            <img src="@/assets/images/icon_stars_1.svg" loading="lazy" alt="" class="image-417">
                            <p class="paragraph-133">"As someone who's tried many NAD+ products, NAD+ is in a league of its own. Pure, effective, and affordable."</p>
                            <div class="reviewer-div">
                                <div class="reviewer-img-div">
                                    <img src="@/assets/images/testi2.webp" loading="lazy" alt="">
                                </div>
                                <div class="reviewer-info">
                                    <div class="text-block-832">Mary J.</div>
                                    <div class="text-block-833">New York, NY</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Table Section - What sets newself apart -->
        <section class="table-section">
            <div class="table-wrap-copy">
                <div class="table-div">
                    <div class="table-div-header">
                        What sets <span class="text-span-184"><strong class="bold-text-41"><img src="@/assets/images/NewSelf_Logo.webp" loading="lazy" sizes="(max-width: 1000px) 100vw, 1000px" srcset="@/assets/images/NewSelf_Logo-p-500.webp 500w, @/assets/images/NewSelf_Logo-p-800.webp 800w, @/assets/images/NewSelf_Logo.webp 1000w" alt="" class="image-418-logo"></strong></span> apart
                    </div>
                    <div class="comparison-table">
                        <div class="table-row top">
                            <div class="table-entry"></div>
                            <div class="ns-column">
                                <img src="@/assets/images/NewSelf_Logo.webp" loading="lazy" alt="" class="image-418">
                            </div>
                            <div class="other-column">
                                <div class="text-block-845">Competition</div>
                            </div>
                        </div>
                        <div class="table-row">
                            <div class="table-entry">
                                <div class="text-block-846">Doctor Prescribed Revolutionary Therapies.</div>
                            </div>
                            <div class="ns-column">
                                <img src="@/assets/images/icon_check_LGreenBlkoutline.svg" loading="lazy" alt="" class="image-419">
                            </div>
                            <div class="other-column">
                                <img src="@/assets/images/icon_check-x.svg" loading="lazy" alt="" class="image-419">
                            </div>
                        </div>
                        <div class="table-row">
                            <div class="table-entry">
                                <div class="text-block-846">Synergistic Supplements for the whole body.<br></div>
                            </div>
                            <div class="ns-column">
                                <img src="@/assets/images/icon_check_LGreenBlkoutline.svg" loading="lazy" alt="" class="image-419">
                            </div>
                            <div class="other-column">
                                <img src="@/assets/images/icon_check-x.svg" loading="lazy" alt="" class="image-419">
                            </div>
                        </div>
                        <div class="table-row">
                            <div class="table-entry">
                                <div class="text-block-846">Access to network of nationwide pharmacies.<br></div>
                            </div>
                            <div class="ns-column">
                                <img src="@/assets/images/icon_check_LGreenBlkoutline.svg" loading="lazy" alt="" class="image-419">
                            </div>
                            <div class="other-column">
                                <img src="@/assets/images/icon_check-x.svg" loading="lazy" alt="" class="image-419">
                            </div>
                        </div>
                        <div class="table-row">
                            <div class="table-entry">
                                <div class="text-block-846">A.I. Enabled Health Optimization Tools.<br></div>
                            </div>
                            <div class="ns-column">
                                <img src="@/assets/images/icon_check_LGreenBlkoutline.svg" loading="lazy" alt="" class="image-419">
                            </div>
                            <div class="other-column">
                                <img src="@/assets/images/icon_check-x.svg" loading="lazy" alt="" class="image-419">
                            </div>
                        </div>
                        <div class="table-row">
                            <div class="table-entry">
                                <div class="text-block-846">Chat &amp; Email Access to Clinical Resources.</div>
                            </div>
                            <div class="ns-column">
                                <img src="@/assets/images/icon_check_LGreenBlkoutline.svg" loading="lazy" alt="" class="image-419">
                            </div>
                            <div class="other-column">
                                <img src="@/assets/images/icon_check-x.svg" loading="lazy" alt="" class="image-419">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Footer - Hidden in modal mode -->
        <footer-section v-if="showFooter" />
    </template>
</div>
</template>

<script>
import {
    mapActions,
    mapGetters
} from 'vuex';
import FooterElement from '@/components/common/footerElement.vue';

export default {
    name: 'ProductTemplate2',
    components: {
        'footer-section': FooterElement
    },
    data() {
        return {
            isLoading: false,
            error: null,
            currentSlide: 0,
            currentVideoSlide: 0,
            videoPlaying: {},
            touchStartX: 0,
            touchEndX: 0,
            slideWidth: 240,
            selectedMedType: 'nasal',
            selectedPlan: 'subscribe',
            originalPrice: 299,
            currentPrice: 105.97,
            productPricing:[
                {
                    "plan_id": "695e9d93212aecbe412f3aa3",
                    "name": "NanoNAD 1000MG - Monthly (Recurring)",
                    "product": "695e938d212aecbe412f3a99",
                    "terms": 1,
                    "price": 199.97
                },
                {
                    "plan_id": "695e9daa212aecbe412f3aa4",
                    "name": "NanoNAD 1000MG - One Time Purchase",
                    "product": "695e938d212aecbe412f3a99",
                    "terms": 0,
                    "price": 250
                },
                {
                    "plan_id": "695e9de1212aecbe412f3aa5",
                    "name": "NanoNAD 1000MG - 3 Months Plan",
                    "product": "695e938d212aecbe412f3a99",
                    "terms": 3,
                    "price": 749.91
                },
                {
                    "plan_id": "696a3de03ec59cc4ce33dde0",
                    "name": "NanoNAD Nasal - 3 Months Plan",
                    "product": "696a3db23ec59cc4ce33ddde",
                    "terms": 3,
                    "price": 749.91
                },
                {
                    "plan_id": "696a3e093ec59cc4ce33dde1",
                    "name": "NanoNAD Nasal - One Time Purchase",
                    "product": "696a3db23ec59cc4ce33ddde",
                    "terms": 0,
                    "price": 225
                },
                {
                    "plan_id": "696a3e473ec59cc4ce33dde2",
                    "name": "NanoNAD Nasal - Monthly (Reccuring)",
                    "product": "696a3db23ec59cc4ce33ddde",
                    "terms": 1,
                    "price": 199.97
                }
            ],
            productImages: [
                require('@/assets/images/Main image_NAD+_Vial+Nasal.webp'),
                require('@/assets/images/Main image_NAD+Vial.webp'),
                require('@/assets/images/Slideimage_Efficacy_NAD+_Vial+Nasal.webp'),
                require('@/assets/images/Slider image_DrQuote_NAD+ Nasal.webp'),
                require('@/assets/images/Slider image_Summary_+Nasal.webp'),
                require('@/assets/images/Slider image_Summary_NAD+Vial.webp'),
                require('@/assets/images/Quote_NAD+ Vial+Nasal.webp'),
                require('@/assets/images/Quote_NAD+ Vial.webp')
            ],
            testimonialVideos: [{
                    poster: 'https://comnewself.s3.us-east-2.amazonaws.com/public/video/ba1-poster-00001.jpg',
                    src: 'https://comnewself.s3.us-east-2.amazonaws.com/public/video/ba1-transcode.mp4'
                },
                {
                    poster: 'https://comnewself.s3.us-east-2.amazonaws.com/public/video/ba2-poster-00001.jpg',
                    src: 'https://comnewself.s3.us-east-2.amazonaws.com/public/video/ba2-transcode.mp4'
                },
                {
                    poster: 'https://comnewself.s3.us-east-2.amazonaws.com/public/video/ba3-poster-00001.jpg',
                    src: 'https://comnewself.s3.us-east-2.amazonaws.com/public/video/ba3-transcode.mp4'
                },
                {
                    poster: 'https://comnewself.s3.us-east-2.amazonaws.com/public/video/ba4-poster-00001.jpg',
                    src: 'https://comnewself.s3.us-east-2.amazonaws.com/public/video/ba4-transcode.mp4'
                },
                {
                    poster: 'https://comnewself.s3.us-east-2.amazonaws.com/public/video/GOOD-Weight-Loss269-poster-00001.jpg',
                    src: 'https://comnewself.s3.us-east-2.amazonaws.com/public/video/GOOD-Weight-Loss269-transcode.mp4'
                },
                {
                    poster: 'https://comnewself.s3.us-east-2.amazonaws.com/public/video/GOOD-Weight-Loss270-poster-00001.jpg',
                    src: 'https://comnewself.s3.us-east-2.amazonaws.com/public/video/GOOD-Weight-Loss270-transcode.mp4'
                },
                {
                    poster: 'https://comnewself.s3.us-east-2.amazonaws.com/public/video/GOOD-Weight-Loss271-poster-00001.jpg',
                    src: 'https://comnewself.s3.us-east-2.amazonaws.com/public/video/GOOD-Weight-Loss271-transcode.mp4'
                },
                {
                    poster: 'https://comnewself.s3.us-east-2.amazonaws.com/public/video/GOOD-Weight-Loss272-poster-00001.jpg',
                    src: 'https://comnewself.s3.us-east-2.amazonaws.com/public/video/GOOD-Weight-Loss272-transcode.mp4'
                },
                {
                    poster: 'https://comnewself.s3.us-east-2.amazonaws.com/public/video/GOOD-Weight-Loss276-poster-00001.jpg',
                    src: 'https://comnewself.s3.us-east-2.amazonaws.com/public/video/GOOD-Weight-Loss276-transcode.mp4'
                },
                {
                    poster: 'https://comnewself.s3.us-east-2.amazonaws.com/public/video/GOOD-Weight-Loss280-poster-00001.jpg',
                    src: 'https://comnewself.s3.us-east-2.amazonaws.com/public/video/GOOD-Weight-Loss280-transcode.mp4'
                }
            ],
            productBullets: [
                '<span class="span_black">No heavy metals</span> and no synthetic chemical byproducts',
                'New, patented, revolutionary approach to <span class="span_black">clean cellular energy.</span>',
                '<span class="span_black">In stock:</span> Free overnight shipping',
                'Each batch of medication undergoes <span class="span_black">extensive quality checks</span>'
            ],
            comparisonTable: [{
                    category: 'How it\'s made',
                    nanonad: 'Bespoke Small Batch Naturally fermented (yeast-based)',
                    others: 'Synthetic, mass production chemical process'
                },
                {
                    category: '% In Circulation',
                    nanonad: '>1%',
                    others: '99%+'
                },
                {
                    category: 'Purity',
                    nanonad: 'Ultra-pure, no byproducts',
                    others: 'Can contain chemical byproducts, heavy metals and toxins.'
                },
                {
                    category: 'How it feels',
                    nanonad: 'Smooth, steady, limited to no burn, only in high dose.',
                    others: 'Burning, stinging, low efficacy.'
                },
                {
                    category: 'Reliability',
                    nanonad: 'Predictable results',
                    others: 'Batch-to-batch issues'
                }
            ],
            competitorComparison: [{
                    header: 'HIGH-PRICED MEDSPA IVs',
                    description: 'They cost $500+ per session, take hours to administer, and deliver a short-lived spike. Despite the premium price, most still use cheap, synthetic NAD.'
                },
                {
                    header: 'STANDARD SUB-Q NAD',
                    description: 'Sub-Q NAD is painful to use, fades fast, and turns daily dosing into a chore — forcing you to use more just to keep up. Most are made with synthetic, mass-produced NAD.'
                },
                {
                    header: 'SNAKE OIL PILLS & LIQUIDS',
                    description: 'Social media is packed with NAD pills and liquids pushed by longevity "gurus" — designed to sell, not work. Most are absorbed in digestion before your cells ever see them.'
                },
                {
                    header: 'OTHER NAD+ (99% OF THE MARKET)',
                    description: 'Other NAD+ is synthetic, poorly absorbed, and forces you to take higher doses just to keep up.'
                }
            ]
        };
    },
    computed: {
        ...mapGetters(['cartItems']),
        cartItemCount() {
            return this.cartItems?.length || 0;
        },
        isInModal() {
            return this.$route.query.modal === 'true';
        },
        showFooter() {
            return !this.isInModal;
        },
        estimatedDelivery() {
            const today = new Date();
            const deliveryDate = new Date(today);
            deliveryDate.setDate(today.getDate() + 3);
            const options = {
                weekday: 'short',
                month: 'short',
                day: 'numeric'
            };
            return deliveryDate.toLocaleDateString('en-US', options);
        },
        // Get the selected product ID based on medication type and dosage
        selectedProductId() {
            if (this.selectedMedType === 'nasal') {
                return '696a3db23ec59cc4ce33ddde'; // NanoNAD Nasal
            } else {
                return '695e938d212aecbe412f3a99'; // NanoNAD 1000MG Injectable
            }
        },
        // Get all plan prices for the selected product
        planPrices() {
            const productId = this.selectedProductId;
            const plans = this.productPricing.filter(p => p.product === productId);

            const oneTime = plans.find(p => p.terms === 0);
            const monthly = plans.find(p => p.terms === 1);
            const threeMonth = plans.find(p => p.terms === 3);

            const formatPrice = (price) => {
                if (!price) return { dollars: '0', cents: '00' };
                const priceStr = price.toFixed(2);
                const [dollars, cents] = priceStr.split('.');
                return { dollars, cents };
            };

            return {
                oneTime: oneTime ? formatPrice(oneTime.price) : { dollars: '299', cents: '00' },
                monthly: monthly ? formatPrice(monthly.price) : { dollars: '274', cents: '97' },
                threeMonth: threeMonth ? formatPrice(threeMonth.price) : { dollars: '749', cents: '91' },
                threeMonthTotal: threeMonth ? threeMonth.price.toFixed(2) : '749.91',
                threeMonthAvg: threeMonth ? formatPrice(threeMonth.price / 3) : { dollars: '249', cents: '97' }
            };
        },
        // Get the currently selected plan object
        selectedPlanObject() {
            const productId = this.selectedProductId;
            const plans = this.productPricing.filter(p => p.product === productId);

            let terms;
            switch (this.selectedPlan) {
                case 'onetime':
                    terms = 0;
                    break;
                case 'subscribe':
                    terms = 1;
                    break;
                case 'quarterly':
                    terms = 3;
                    break;
                default:
                    terms = 1;
            }

            return plans.find(p => p.terms === terms) || plans[0];
        },
        // Calculate monthly savings (oneTime price - monthly price)
        monthlySavings() {
            const oneTimePrice = parseFloat(this.planPrices.oneTime.dollars + '.' + this.planPrices.oneTime.cents);
            const monthlyPrice = parseFloat(this.planPrices.monthly.dollars + '.' + this.planPrices.monthly.cents);
            return Math.round(oneTimePrice - monthlyPrice);
        },
        // Calculate quarterly savings per month (oneTime price - threeMonth avg)
        quarterlySavings() {
            const oneTimePrice = parseFloat(this.planPrices.oneTime.dollars + '.' + this.planPrices.oneTime.cents);
            const threeMonthAvg = parseFloat(this.planPrices.threeMonthAvg.dollars + '.' + this.planPrices.threeMonthAvg.cents);
            return Math.round(oneTimePrice - threeMonthAvg);
        },
        // Display the original (inflated) price - 25% higher than one-time price
        displayOriginalPrice() {
            const oneTimePrice = parseFloat(this.planPrices.oneTime.dollars + '.' + this.planPrices.oneTime.cents);
            return Math.ceil(oneTimePrice * 1.25);
        },
        // Display the current price based on selected plan
        displayCurrentPrice() {
            const plan = this.selectedPlanObject;
            if (!plan) return '0.00';

            // For 3-month plan, show the average monthly price
            if (this.selectedPlan === 'quarterly') {
                return (plan.price / 3).toFixed(2);
            }
            return plan.price.toFixed(2);
        },
        // Check if buttons should be shown based on URL parameter
        showButtons() {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get('show_button') !== 'false';
        },
        videoPairs() {
            const pairs = [];
            for (let i = 0; i < this.testimonialVideos.length; i += 2) {
                const pair = [];
                pair.push({
                    ...this.testimonialVideos[i],
                    originalIndex: i
                });
                if (i + 1 < this.testimonialVideos.length) {
                    pair.push({
                        ...this.testimonialVideos[i + 1],
                        originalIndex: i + 1
                    });
                }
                pairs.push(pair);
            }
            return pairs;
        },
        sliderStyle() {
            const offset = this.currentVideoSlide * this.slideWidth;
            return {
                transform: `translateX(-${offset}px)`,
                transition: 'transform 0.3s ease'
            };
        },
        totalSlides() {
            // Returns array for v-for, showing dots for each "page" of 2 videos
            // 10 videos = 5 pages (dots)
            const total = Math.ceil(this.testimonialVideos.length / 2);
            return Array.from({
                length: total
            }, (_, i) => i);
        },
        currentDotIndex() {
            // Which dot should be active based on currentVideoSlide
            return Math.floor(this.currentVideoSlide / 2);
        }
    },
    methods: {
        ...mapActions(['setCartVisibility']),
        openCart() {
            this.setCartVisibility(true);
        },
        prevSlide() {
            this.currentSlide = this.currentSlide > 0 ?
                this.currentSlide - 1 :
                this.productImages.length - 1;
        },
        nextSlide() {
            this.currentSlide = this.currentSlide < this.productImages.length - 1 ?
                this.currentSlide + 1 :
                0;
        },
        prevVideoSlide() {
            // Move by 2 videos (one page)
            const maxSlide = Math.max(0, this.testimonialVideos.length - 2);
            if (this.currentVideoSlide >= 2) {
                this.currentVideoSlide -= 2;
            } else {
                // Loop to the last page
                this.currentVideoSlide = Math.floor(maxSlide / 2) * 2;
            }
        },
        nextVideoSlide() {
            // Move by 2 videos (one page)
            const maxSlide = Math.max(0, this.testimonialVideos.length - 2);
            if (this.currentVideoSlide + 2 <= maxSlide) {
                this.currentVideoSlide += 2;
            } else {
                // Loop back to start
                this.currentVideoSlide = 0;
            }
        },
        goToSlide(index) {
            // Each dot represents a page of 2 videos
            const maxSlide = Math.max(0, this.testimonialVideos.length - 2);
            this.currentVideoSlide = Math.min(index * 2, maxSlide);
        },
        handleTouchStart(event) {
            this.touchStartX = event.touches[0].clientX;
        },
        handleTouchMove(event) {
            this.touchEndX = event.touches[0].clientX;
        },
        handleTouchEnd() {
            const swipeThreshold = 50;
            const diff = this.touchStartX - this.touchEndX;

            if (Math.abs(diff) > swipeThreshold) {
                if (diff > 0) {
                    // Swiped left - go to next
                    this.nextVideoSlide();
                } else {
                    // Swiped right - go to previous
                    this.prevVideoSlide();
                }
            }

            // Reset touch values
            this.touchStartX = 0;
            this.touchEndX = 0;
        },
        toggleVideo(index) {
            const video = document.getElementById('video-' + index);
            if (video) {
                if (video.paused) {
                    const playPromise = video.play();
                    if (playPromise !== undefined) {
                        playPromise.then(() => {
                            this.$set(this.videoPlaying, index, true);
                        }).catch((error) => {
                            console.error('Video play failed:', error);
                            this.$set(this.videoPlaying, index, false);
                        });
                    } else {
                        this.$set(this.videoPlaying, index, true);
                    }
                } else {
                    video.pause();
                    this.$set(this.videoPlaying, index, false);
                }
            }
        },
        onVideoLoaded(index) {
            console.log('Video loaded successfully:', index);
        },
        onVideoError(index, event) {
            console.error('Video error for index', index, ':', event.target.error);
        },
        scrollToProduct() {
            const productSection = document.querySelector('.product-section');
            if (productSection) {
                productSection.scrollIntoView({
                    behavior: 'smooth'
                });
            }
        },
        addToCart() {
            const plan = this.selectedPlanObject;
            const cartItem = {
                id: plan.plan_id,
                name: plan.name,
                category: 'Longevity',
                price: plan.price,
                retail_price: plan.price,
                subheader: 'NAD+ Supplement',
                sku: `NAD_1000_${this.selectedMedType.toUpperCase()}`,
                stripe_id: plan.plan_id,
                quantity: 1,
                image: this.productImages[0],
                is_addon: false,
                medType: this.selectedMedType,
                dosage: '1000',
                plan: this.selectedPlan,
                product_id: plan.product
            };

            this.$store.dispatch('addToCart', cartItem);
            this.setCartVisibility(true);
        },
        getPriceForPlan() {
            const plan = this.selectedPlanObject;
            return plan ? plan.price : 0;
        },
        updateSlideWidth() {
            // Calculate slide width based on viewport
            const width = window.innerWidth;
            if (width <= 479) {
                this.slideWidth = 158; // 150px + 8px margin
            } else if (width <= 767) {
                this.slideWidth = 190; // 180px + 10px margin
            } else {
                this.slideWidth = 240; // 225px + 15px margin
            }
        }
    },
    mounted() {
        // Calculate slide width dynamically based on container
        this.$nextTick(() => {
            this.updateSlideWidth();
            window.addEventListener('resize', this.updateSlideWidth);
        });

        // If in modal mode, prevent body horizontal scroll
        if (this.isInModal) {
            document.body.style.overflowX = 'hidden';
            document.documentElement.style.overflowX = 'hidden';
        }
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateSlideWidth);

        // Clean up modal mode body styles
        if (this.isInModal) {
            document.body.style.overflowX = '';
            document.documentElement.style.overflowX = '';
        }
    }
};
</script>

<style scoped>
.loading-overlay2 {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}

/* Video Slider Styles - Vue Implementation */
.videos-slider-3 {
    position: relative;
    overflow: visible;
    width: 100%;
    height: auto !important;
}

.videos-slider-3 .mask-8 {
    display: block !important;
    overflow: hidden !important;
}

.videos-slider-3 .slider-track {
    display: flex;
    flex-wrap: nowrap;
}

.videos-slider-3 .video-slide-3 {
    flex: 0 0 auto;
    width: 225px;
    margin-right: 15px;
}

.videos-slider-3 .video-card-div {
    width: 100%;
    height: 400px;
    border-radius: 12px;
    overflow: hidden;
    position: relative;
}

.videos-slider-3 .background-video-13 {
    width: 100%;
    height: 100%;
    position: relative;
}

.videos-slider-3 .background-video-13 video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block !important;
    z-index: 0;
    position: relative;
}

.videos-slider-3 .play-pause-button {
    position: absolute;
    bottom: 15px;
    right: 15px;
    background: transparent;
    border: none;
    padding: 0;
    cursor: pointer;
    z-index: 10;
}

.videos-slider-3 .play-pause-button span {
    display: block;
}

.videos-slider-3 .play-pause-button span[hidden] {
    display: none;
}

.videos-slider-3 .play-pause-button img {
    width: 24px;
    height: 24px;
}

/* Dots Navigation - override absolute positioning from global w-slider-nav */
.videos-slider-3 .slide-nav-8 {
    position: relative !important;
    display: flex !important;
    justify-content: center;
    gap: 8px;
    padding-top: 15px;
    top: auto !important;
    bottom: auto !important;
    right: auto !important;
    left: auto !important;
}

/* UGC Section Container */
.ugc-div {
    margin-top: 20px;
    padding: 20px 0;
}

.ugc-div .text-block-1783 {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 15px;
    text-align: center;
}

/* Responsive adjustments */
@media screen and (max-width: 767px) {
    .videos-slider-3 .video-slide-3 {
        width: 180px;
        margin-right: 10px;
    }

    .videos-slider-3 .video-card-div {
        height: 320px;
    }

    .videos-slider-3 .left-arrow-19,
    .videos-slider-3 .right-arrow-17 {
        width: 35px !important;
        height: 35px !important;
    }

    .videos-slider-3 .icon-51 {
        font-size: 20px;
    }
}

@media screen and (max-width: 479px) {
    .videos-slider-3 .video-slide-3 {
        width: 150px;
        margin-right: 8px;
    }

    .videos-slider-3 .video-card-div {
        height: 280px;
    }

    .videos-slider-3 .left-arrow-19,
    .videos-slider-3 .right-arrow-17 {
        width: 32px !important;
        height: 32px !important;
    }

    .videos-slider-3 .icon-51 {
        font-size: 18px;
    }
}

.videos-div-copy-copy-2 .videos-slider-3 .play-pause-button {
    bottom: 0;
    right: 0;
    left: 0;
    top: 0;
}

/* Modal Mode Styles - Applied when embedded in iframe with modal=true */
.modal-mode {
    overflow-x: hidden;
    max-width: 100%;
    box-sizing: border-box;
}

.modal-mode * {
    box-sizing: border-box;
}

.modal-mode .product-section {
    padding-top: 0;
}

.modal-mode .nad-product-div-wrap {
    padding: 20px 40px;
    max-width: 100%;
    overflow-x: hidden;
}

.modal-mode .product-div-box {
    gap: 24px;
}

.modal-mode .product-images-div {
    max-width: 100%;
}

.modal-mode .img-links-div {
    padding-left: 20px;
    padding-right: 20px;
}

.modal-mode section {
    max-width: 100%;
    overflow-x: hidden;
    padding-left: 20px;
    padding-right: 20px;
}

/* Mobile adjustments for modal */
@media screen and (max-width: 768px) {
    .modal-mode .nad-product-div-wrap {
        padding: 12px 20px;
    }

    .modal-mode .product-div-box {
        flex-direction: column;
    }

    .modal-mode .product-images-div {
        width: 100%;
    }
}
</style>
